import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import ConfirmationDialog from "../../../../components/dialog/simple-alert";
import { RoleFormData } from "../../../../interfaces/RoleFormData";

interface Props {
  openDialog: boolean;
  handleDialogClose(): void;
  handleDialogSave(): void;
  defaultValue: RoleFormData;
  onChangeValue(formData: RoleFormData): void;
}

interface Validation {
  name: boolean;
  menu: boolean;
}

const DEFAULT_FORM_VALUE: RoleFormData = {
  name: "",
  accesses: [
    { menuName: "Home", menuValue: false },
    { menuName: "Master Role", menuValue: false },
    { menuName: "Master User", menuValue: false },
    { menuName: "List of Request", menuValue: false },
    // { menuName: "CRR Report", menuValue: false },
  ],
};

export function RoleForm({
  openDialog,
  handleDialogClose,
  handleDialogSave,
  defaultValue,
  onChangeValue,
}: Props): JSX.Element {
  const [validation, setValidation] = useState<Validation>({
    menu: false,
    name: false,
  });
  const [dialog, setDialog] = useState(false);

  useEffect(() => {
    if (defaultValue?.name !== "") {
      setValidation({ menu: false, name: false });
    }
  }, [defaultValue]);

  return (
    <>
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <Paper
          style={{
            width: "400px",
            padding: "15px",
          }}
        >
          <div>
            <ul>
              {validation?.name && (
                <li style={{ color: "red" }}>Role name cannot be empty.</li>
              )}
              {validation?.menu && (
                <li style={{ color: "red" }}>
                  Role menu access cannot be less than one.
                </li>
              )}
            </ul>
          </div>
          <DialogContent>
            <DialogContentText sx={{ textAlign: "left" }}>
              <div>
                <InputLabel htmlFor="standard-helperText" className="black">
                  <b>
                    Nama Role / <i>Role Name </i>
                    <span style={{ color: "red" }}>
                      <span style={{ color: "red" }}> *</span>
                    </span>
                  </b>
                </InputLabel>
                <TextField
                  required
                  id="standard-helperText"
                  placeholder="Input Nama Role"
                  value={defaultValue.name}
                  onChange={(e) =>
                    onChangeValue({ ...defaultValue, name: e.target.value })
                  }
                  className="perbesar-width"
                  variant="standard"
                />
                <FormGroup>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <div>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                        className="black"
                      >
                        Menu
                      </Typography>
                    </div>
                    <div style={{ flex: 1, textAlign: "right" }}>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                        className="black"
                      >
                        Access
                      </Typography>
                    </div>
                  </div>

                  {defaultValue.accesses.map((acc) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                      className="black"
                      key={acc.menuName}
                    >
                      <div>
                        <Typography variant="body1">{acc.menuName}</Typography>
                      </div>
                      <div style={{ flex: 1, textAlign: "right" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={acc.menuValue}
                              onChange={() =>
                                onChangeValue({
                                  ...defaultValue,
                                  accesses: defaultValue.accesses.map(
                                    (item) => {
                                      if (item.menuName === acc.menuName) {
                                        return {
                                          ...item,
                                          menuValue: !item.menuValue,
                                        };
                                      }
                                      return item;
                                    }
                                  ),
                                })
                              }
                              color="primary"
                            />
                          }
                          label=""
                        />
                      </div>
                    </div>
                  ))}
                </FormGroup>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <Button
              sx={{ background: "#898989", width: "100%" }}
              variant="contained"
              onClick={() => {
                handleDialogClose();
                onChangeValue(DEFAULT_FORM_VALUE);
              }}
            >
              Cancel
            </Button>
            <Button
              sx={{ width: "100%" }}
              variant="contained"
              onClick={() => {
                setValidation({
                  name: defaultValue.name === "",
                  menu: !defaultValue.accesses.some(
                    (e) => e.menuValue === true
                  ),
                });
                if (
                  defaultValue.name !== "" &&
                  defaultValue.accesses.some((e) => e.menuValue === true)
                ) {
                  setDialog(true);
                }
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>
      <ConfirmationDialog
        open={dialog}
        title="Confirmation Title"
        message="Are you sure you want to proceed?"
        onConfirm={() => {
          handleDialogSave();
          setDialog(false);
          handleDialogClose();
        }}
        onCancel={() => {
          setDialog(false);
        }}
      />
    </>
  );
}
